import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";
import { actions as formActions } from "2g-form";
import { dispatchModuleAction } from "2g-utils-redux";

import { DATA } from "b2b/api/paths";
import useMessages from "./i18n/useMessages";

export const FORM_MODULE_KEY = "zadostEditaceForm";

export default function useZadostEditaceWidget({ zadost, reload }) {
  const { saveDialogTitle } = useMessages();
  const { showDialog, hideDialog } = useDialogsProvider();
  const dispatch = useDispatch();

  useEffect(() => {
    zadost &&
      dispatchModuleAction(
        dispatch,
        FORM_MODULE_KEY,
        formActions.setValues({
          strojvedouci: zadost.strojvedouci,
          poznamkaSpravce: zadost.poznamkaSpravce
        })
      );
  }, [zadost]);

  const handleSuccess = useCallback(() => {
    hideDialog();
    reload();
  }, [hideDialog, reload]);

  const handleSubmit = useCallback(
    ({ values, submitter }) => {
      showDialog(ZpracDialog, {
        url: DATA.zadostPoznamky(zadost.id),
        method: "put",
        payload: values,
        title: saveDialogTitle(),
        onClose: hideDialog,
        onSuccess: handleSuccess
      });
    },
    [showDialog, handleSuccess, zadost]
  );

  return {
    formModuleKey: FORM_MODULE_KEY,
    onSubmit: handleSubmit
  };
}
